import Link from "next/link";
import { useSelector } from "react-redux";
import clsx from "clsx";
import styles from "./index.module.scss";
import Picture from "./picture";
import Files from "/components/pages/product/files";
import { formatType } from "../../../../utils";
import Sert from "../../product/sert";
import Buttons from "./buttons";
import Qty from "./qty";
import Price from "./price";
import Props from "./props";
import InstallPrice from "./installPrice";

export default function Product({
  data,
  viewType,
  managerData,
  managerComment,
  managerInstall,
}) {
  const { cityName } = useSelector((state) => state.location);
  const { sections } = useSelector((state) => state.sections);

  const images = data.PHOTOS_NEW?.map((pictureId) => {
    const path1 = pictureId.substr(0, 2);
    const path2 = pictureId.substr(2, 2);
    const path3 = pictureId.substr(4);
    return `/images/${path1}/${path2}/${path3}/small.webp`;
  });

  return (
    <div
      className={styles.Wrapper}
      itemScope
      itemType="http://schema.org/Product"
      onClick={() => {
        window.dataLayer = window.dataLayer || [];
        // eslint-disable-next-line no-undef
        dataLayer.push({
          ecommerce: {
            currencyCode: "RUB",
            click: {
              products: [
                {
                  id: data.ID,
                  name: data.NAME,
                  price: data.CATALOG?.MIN_PRICE,
                  category: sections[data.IBLOCK_SECTION_ID].NAME,
                  brand: data.BRAND?.name,
                  list: "Каталог",
                },
              ],
            },
          },
        });
      }}
    >
      <div
        className={clsx(styles.Product, viewType === 1 && styles.ProductTable)}
      >
        <div className={styles.Left}>
          <div className={styles.Photos}>
            {data.DETAIL_PAGE_URL && (
              <Picture
                stick={data.STICK}
                name={data.NAME}
                alt={`${data.NAME} ${data.ARTICLE?.VALUE} в ${cityName}`}
                link={data.DETAIL_PAGE_URL ?? "/"}
                video={data.VIDEO}
                path={data.DETAIL_PAGE_URL}
                images={images}
              />
            )}
          </div>
          <div className={styles.Files}>
            <Files file={data.FILE} />
            <Sert sert={data.SERT} />
          </div>
        </div>
        <div
          className={styles.Right}
          itemProp="offers"
          itemScope
          itemType="http://schema.org/Offer"
        >
          <div className={styles.Top}>
            <div className={styles.Art}>Артикул {data.ARTICLE?.VALUE}</div>
            <Qty product={data} />
          </div>
          <Link href={data.DETAIL_PAGE_URL ?? "/"}>
            <a className={styles.Name} itemProp="url">
              <span itemProp="name">{formatType(data.NAME)}</span>
            </a>
          </Link>
          <span style={{ display: "none" }} itemProp="description">
            {data.NAME}
          </span>
          <InstallPrice product={data} />
          {typeof managerInstall === "object" &&
            Object.keys(managerInstall).length > 0 && (
              <div className={styles.ManagerInfo}>
                {Object.keys(managerInstall).map((itemKey) => (
                  <div key={itemKey}>
                    <div>
                      {itemKey} - {managerInstall[itemKey]} мин
                    </div>
                  </div>
                ))}
              </div>
            )}
          {Boolean(managerComment) && (
            <span
              className={styles.ManagerInfo}
              style={{ color: "red" }}
              dangerouslySetInnerHTML={{ __html: managerComment }}
            ></span>
          )}
          <Price product={data} />
          <div className={styles.Bottom}>
            <div>
              <Props
                props={data.PROPERTIES}
                filterUrl={data.FILTER_URL}
                isBaltex={false}
              />
            </div>
            <Buttons product={data} />
          </div>
        </div>
      </div>
      {Boolean(managerData) && (
        <div className={styles.ManagerWrapper}>
          <div
            className={styles.ManagerData}
            dangerouslySetInnerHTML={{ __html: managerData }}
          />
        </div>
      )}
    </div>
  );
}
